import React from 'react';
import { TagCloud } from 'react-tagcloud'

const WordGraph = (props) => {
    // console.log(props.data)
    var data = props.data

    if (data!==null)
    {
      return <TagCloud
        minSize={12}
        maxSize={35}
        tags={data}
        onClick={tag => alert(`'${tag.value}' was selected!`)}
      />  
    }

    else{
      return <p>No specified Keywords</p>
    }
    
}

export default WordGraph;

